// @flow
/** @jsx jsx */

import { Colors } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import { getHostedFieldId } from '../utils';

import SensitiveData from '@zapier/payment/src/components/SensitiveData';
import type {
  HostedFieldType,
  HostedFieldValue,
} from '@zapier/payment/src/types';

type Props = {
  /** Show error styling */
  hasError: boolean,
  /** Call when field changes value */
  onChange: (value: HostedFieldValue) => void,
  /** Field type to show */
  type: HostedFieldType,
};

const Styles = {
  container: (props: Props) => ({
    alignItems: 'center',
    background: props.hasError ? Colors.red100 : Colors.grey100,
    borderRadius: 10,
    border: `2px solid ${props.hasError ? Colors.red600 : Colors.grey100}`,
    boxSizing: 'content-box',
    display: 'flex',
    height: 19,
    overflow: 'hidden',
    padding: 10,

    '> *': {
      flex: '0 0 100%',
    },
  }),
};

const HostedField = (props: Props) => (
  <div css={Styles.container(props)}>
    <SensitiveData>
      <div id={getHostedFieldId(props.type)} />
    </SensitiveData>
  </div>
);

export default HostedField;
